<template>
  <div class="designs">
    <div class="covers" v-loading="isLoading">
      <div class="card-item" v-for="item in designData.list" :key="item.schemeId">
        <Cover
          :bgConfig="item.bgParameter"
          :elementImg="item.elementImg"
          :size="setCoverSize(item.size)"
          :elConfig="item.elementInfo"
          :textConfig="item.textInfo"
          :fontStyles="item.fontStyles"
        />
        <div class="mask">
          <span class="btn" @click="toDesignDetail(item.schemeId)"> <i class="el-icon-edit"></i>编辑 </span>
          <span class="btn" @click="delectConfirm(item.schemeId)"><i class="el-icon-delete"></i>删除</span>
        </div>
        <span class="save-time">保存于: {{ formatTime(item.time) }}</span>
        <div class="caption">
          <span class="count">共计 {{ item.count }} 张</span>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        v-if="designData.totalPage"
        :key="2"
        background
        layout="prev, pager, next"
        :page-count="designData.totalPage"
        @current-change="getDesginList"
        @prev-click="getDesginList(--pageIndex)"
        @next-click="getDesginList(++pageIndex)"
      >
      </el-pagination>
    </div>
    <div v-if="isLoading" class="loading">loading...</div>
    <div class="nothing" v-if="!designData.totalCount">
      <span class="tips">您还没有添加内容，赶紧去添加吧</span>
      <button class="btn" @click="toDesign">开始创意</button>
    </div>
    <el-dialog title="提示" :visible.sync="delectDialogVisible" top="25vh" width="400px" left>
      <span class="msg"><i class="iconfont icon-jingshi"></i>是否删除当前文件？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="immediateDelete(currentDesign)">删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/plugins/http";
import api from "@/assets/scripts/api";
import Cover from "@/pages/cover/components/cover.vue";
import { mapMutations } from "vuex";
export default {
  name: "coverDesigns",
  props: {
    designData: {
      type: Object,
      default: () => {},
    },
    userId: {
      type: String,
      default: "",
    },
    sizeId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 要删除的设计id
      currentDesign: "",
      // 设计总数
      totalCount: 0,
      pageSize: 50,
      pageIndex: 1,
      isLoading: false,
      hasMore: true,
      delectDialogVisible: false,
    };
  },
  components: {
    Cover,
  },
  async mounted() {
    this.getDesginList(1);
  },
  watch: {
    designData: {
      handler(newData) {
        if (newData && newData.list && this.$refs.waterfall) {
          this.$nextTick(() => {
            this.$refs.waterfall.refresh();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("cover", ["clearCoverCacheInfo"]),
    getDesginList(pageIndex) {
      this.pageIndex = pageIndex;
      this.$emit("getMyDesigns", {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        platformType: 2,
        userId: this.userId,
        sizeId: this.sizeId,
      });
    },
    // 格式化日期
    formatTime(timeStamp) {
      const creatTime = Date.parse(new Date(timeStamp));
      const nowTime = Date.parse(new Date());
      const timePoor = nowTime - creatTime;
      if (timePoor <= 3600000) {
        return "刚刚";
      } else if (timePoor > 3600000 && timePoor < 86400000) {
        return `${Math.round(timePoor / 3600000)}小时前`;
      } else {
        return `${Math.round(timePoor / 86400000)}天前`;
      }
    },
    // 设置瀑布流里图片的大小
    setCoverSize({ width, height }) {
      if (width >= 300) {
        const colHeight = (300 * height) / width;
        return {
          width: 300,
          height: colHeight,
        };
      } else {
        return {
          width,
          height,
        };
      }
    },
    delectConfirm(id) {
      this.currentDesign = id;
      this.delectDialogVisible = true;
    },
    // 删除我的设计
    async immediateDelete(id) {
      let { code } = await http.delete(api.deleteSchemeByUser, {
        schemeId: id,
        userId: this.userId,
      });
      if (code === 10000) {
        this.hasMore = true;
        this.getDesginList(1);
      }
      this.$message({
        type: "success",
        message: "删除成功!",
      });
      this.delectDialogVisible = false;
    },
    // 去详情页面
    toDesignDetail(schemeId) {
      this.$emit("showDesignDetail", schemeId);
    },
    // 去创意页面
    toDesign() {
      this.$emit("showDesignDetail");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.designs {
  @include scroller;
}
.covers {
  width: 100%;
  padding: 30px 30px 100px;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  gap: 20px;
}
.card-item {
  position: relative;
  box-sizing: border-box;
  width: 324px;
  padding: 12px 12px 44px;
  background-color: #fff;
  border-radius: 12px;
  .cover {
    margin: auto;
  }
}
.loading,
.no-more {
  text-align: center;
  padding: 20px 0;
}
</style>
